module.exports = __webpack_public_path__ + "static/img/property3.29d81dd.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/property3.jpeg
// module id = M1wJ
// module chunks = 0